import { render, staticRenderFns } from "./CashOnDeliveryTag.vue?vue&type=template&id=b2801ce8&scoped=true&"
import script from "./CashOnDeliveryTag.vue?vue&type=script&lang=js&"
export * from "./CashOnDeliveryTag.vue?vue&type=script&lang=js&"
import style0 from "./CashOnDeliveryTag.vue?vue&type=style&index=0&id=b2801ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2801ce8",
  null
  
)

export default component.exports